import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormGroup } from '@angular/forms';
import { apiEndNode } from './apiEndNode';

const NODE_TYPE = "apiEndNode";

@Component({
  selector: 'app-api-end-node',
  templateUrl: './api-end-node.component.html',
  styleUrls: ['./api-end-node.component.scss']
})
export class ApiEndNodeComponent extends NodeBuilder implements OnInit {

  readonly responseContentTypeGroup = [
    { key: 'applicationJSON', value: 'application/json' },
    { key: 'applicationXML', value: 'application/xml' },
    { key: 'textPlain', value: 'text/plain' },
    { key: 'textXML', value: 'text/xml' }
  ];

  apiEndNodeForm: FormGroup;

  constructor() {
    super(NODE_TYPE)
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.apiEndNodeForm = apiEndNode.toForm(stepData, this.canEdit);
  }

  get getStepData(): {} {
    const formData = this.apiEndNodeForm.getRawValue();
    return new apiEndNode(formData).nodeData;
  }

  get isNodeValid(): boolean {
    this.apiEndNodeForm.markAllAsTouched();
    return this.apiEndNodeForm.valid;
  }
}
